import { StamdataUtlandHelgradModel } from '../../Models/StamdataUtlandHelgradModel';
import LandOgUniversitetModel from '../../../Shared/Scripts/Models/LandOgUniversitetModel';

export const SET_SATSER = 'SET_SATSER';
export const SET_UNIVERSITETER = 'SET_UNIVERSITETER';

export interface SetSatserAction {
    type: typeof SET_SATSER;
    payload: StamdataUtlandHelgradModel;
}

export interface SetUniversiteterAction {
    type: typeof SET_UNIVERSITETER;
    payload: Array<LandOgUniversitetModel>
}

export type UniversitTypes = SetUniversiteterAction;
export type SatserActionTypes = SetSatserAction;